module.exports = __webpack_public_path__ + "static/media/logo8.6daaf9e5.png";